export default __webpack_public_path__ + "static/Begin your journey-8abf4391ac470b3347449fcc6e5df83a.webp";